export { default } from './formatCurrency';
